<template>
    <div>
        <Lbls>/components/groups/ProfileGroups</Lbls>
        <v-chip color="primary"v-for="(g,i) in groups"
                :small="$vuetify.breakpoint.smAndUp"
                :outlined="large!==g.id"
                :close="large===g.id"
                @click:close="removeFromGroup(g,i,'remove')"
                @click="confirmDelete(g)"
                @mouseleave="cancelDelete(g)"
                pill
                 >
            <v-btn icon class="hc"
                   :to="`/myathleteslists?active=${g.id}`"
                   v-if="large===g.id"
                   :loading="loading===g.id">
                <v-icon left  >mdi-arrow-left-circle</v-icon>
            </v-btn>
            {{g.name}}
        </v-chip>
    </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import Lbls from "@/components/Lbls";

  export default {
    props:['profilekey', 'groupids'],
    name: "ProfileGroups",
    components: {Lbls},
    data() {
      return {
        groups:undefined,
        large:undefined,
        deleting:false,
        loading:undefined,
        label: false
      }
    },
    computed: {
      ...mapState(['dev','lbls'])
    },
    watch:{
      groupids(n,o){
        if(n.length>0){
          this.getProfileGroups()
        }
      }
    },
    created(){

    },
    methods: {
      ...mapActions(['get', 'post']),
      async getProfileGroups(){
        let rsp = await this.post({path:'api/profilesv2/getprofilegroups',body:{groups:this.groupids}})
        this.groups = rsp
      },
      cancelDelete(e,i){
        this.deleting=false;
        this.large=undefined;
      },
      confirmDelete(e,i){
        console.log(e)
        if(!this.deleting){
          this.deleting=true;
          this.large=e.id;
          return
        }else{
          this.deleting=false;
          this.large=undefined;
        }
      },
      async removeFromGroup(e,i,action){
        //PASS IN DELETE FOR THE ACTION AND IT DELETES IT..
        this.loading=e.id
        let rsp = await this.post({
          path:'api/profilesv2/addtogroup',
          body:{groupid:e.id,keystoadd:[this.profilekey],action:'remove'}})
        console.log(rsp)
        this.groups.splice(i,1)
        this.deleting=false;
        this.large=undefined;
        this.$emit('done',rsp)
      }
    }
  }

</script>

<style scoped>
    .hc:hover{
        transform: scale(1.8);
        position: relative;
        z-index:5;
    }
</style>